import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { TimePickerComponent } from '../../../../../components/time-picker/time-picker.component';
import { TranslateService } from '@services/translate/translate.service';

@Component({
  selector: 'activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
  standalone: false
})
export class ActivityComponent implements OnInit {

  @Input() dynamicContent: Models.DynamicContent;
  @Input() parent: Models.DynamicContentEntrance;

  categories: Models.DynamicContentCategory[] = [];
  weekdayArray = [1, 2, 3, 4, 5, 6, 0];
  weekdays = { 0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true };

  constructor(private dialog: MatDialog, private dynamicContentService: DynamicContentService, private translate: TranslateService) {
    this.translate.get('dynamicContent');
    for (const element of this.dynamicContent?.content?.weekdays || []) {
      this.weekdays[element] = true;
    }
  }

  async ngOnInit() {
    if (this.parent?.categories?.length) {
      this.categories = (await this.dynamicContentService.find(0, 100, { type: 'category', _id: { $in: this.parent.categories } })).data;
    }
  }

  change(event, field, isContent = false) {
    if (isContent) {
      this.dynamicContent.content[field] = event;
    } else {
      this.dynamicContent[field] = event;
    }
  }

  updateWeekdays(i: number) {
    this.weekdays[i] = !this.weekdays[i];
    this.dynamicContent.content.weekdays = Object.keys(this.weekdays).filter(key => this.weekdays[key]).map(Number);
  }

  openTimePicker(time: string, type: string) {
    let dialogRef: MatDialogRef<TimePickerComponent>;

    if (time === undefined) {
      time = null;
    }

    dialogRef = this.dialog.open(TimePickerComponent, {
      width: '398px',
      height: '548px',
      panelClass: 'time',
      data: time
    });
    dialogRef.afterClosed().toPromise().then((result: any) => {
      if (!result) {
        return;
      }
      let hour = result.hour;
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (hour === 24) {
        hour = '00';
      }
      let minute = result.minute;
      if (minute < 10) {
        minute = '0' + minute;
      }
      if (type.startsWith('start')) {
        this.dynamicContent.content.startTime.publishStartTime = hour + ':' + minute;
      } else {
        this.dynamicContent.content.endTime = hour + ':' + minute;
      }
    });
  }

}
